var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_62_7258)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 4C2.73478 4 2.48043 4.10536 2.29289 4.29289C2.10536 4.48043 2 4.73478 2 5V19C2 19.2652 2.10536 19.5196 2.29289 19.7071C2.48043 19.8946 2.73478 20 3 20H17C17.2652 20 17.5196 19.8946 17.7071 19.7071C17.8946 19.5196 18 19.2652 18 19V13.66C18 13.1077 18.4477 12.66 19 12.66C19.5523 12.66 20 13.1077 20 13.66V19C20 19.7957 19.6839 20.5587 19.1213 21.1213C18.5587 21.6839 17.7957 22 17 22H3C2.20435 22 1.44129 21.6839 0.87868 21.1213C0.31607 20.5587 0 19.7957 0 19V5C0 4.20435 0.31607 3.44129 0.87868 2.87868C1.44129 2.31607 2.20435 2 3 2H8.34C8.89228 2 9.34 2.44772 9.34 3C9.34 3.55228 8.89228 4 8.34 4H3Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2929 0.292893C16.6834 -0.0976311 17.3166 -0.0976311 17.7071 0.292893L21.7071 4.29289C22.0976 4.68342 22.0976 5.31658 21.7071 5.70711L11.7071 15.7071C11.5675 15.8467 11.3897 15.9419 11.1961 15.9806L6.1961 16.9806C5.86824 17.0462 5.5293 16.9435 5.29288 16.7071C5.05646 16.4707 4.95383 16.1317 5.01941 15.8039L6.01941 10.8039C6.05812 10.6103 6.15328 10.4325 6.29288 10.2929L16.2929 0.292893ZM7.92119 11.493L7.27474 14.7252L10.507 14.0788L19.5858 5L17 2.41421L7.92119 11.493Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_62_7258"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.3d1228ffb3aed89852d6325ff04031c0.svg";
export { ForwardRef as ReactComponent };